<template>
  <section class="content">
    <div class="row center-block">
      <div class="col-xs-12 p-x-0 m-b-10 flex align-center">
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h3 class="box-title">新增{{tabName}}</h3>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="row form-inline">
              <div class="col-sm-12 table-responsive p-x-0">
                <table aria-describedby="example1_info" role="grid" id="example1" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">#</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">名稱</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">商品料號</th>
                    <th colspan="1" rowspan="1" aria-controls="example1" tabindex="0" class="">備註</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr class="even" role="row" v-for="(element, index) in elementList">
                    <!-- cloumn 0 -->
                    <td class="sorting_1">{{index + 1}}</td>
                    <!-- column 1-->
                    <td>
                      <input class="form-control" v-model="element.name" :placeholder="tabNamePlaceholder" maxlength="70">
                    </td>
                    <td>
                      <input class="form-control" v-model="element.vendor_custom_id" placeholder="對應POS_id">
                    </td>
                    <td>
                      <input class="form-control" v-model="element.remark" placeholder="備註">
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xs-12 text-right">
                <button class="btn btn-primary" @click="addElement()">再新增{{tabName}}</button>
              </div>
            </div>
          </div>
          <div class="box-footer text-center">
            <button class="btn btn-fail" @click="gotoOut">
              返回
            </button>
            <button class="btn btn-success" @click="checkAddBinding">
              新增
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import bindingTable from './Temp/BindingTable.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'cr-binding',
  extends: NdExtendHandleMenu,
  components: {
    'binding-table': bindingTable
  },
  data () {
    return {
      storeName: '',
      menuState: 4,
      name: '迷客夏',
      total: 1,
      count: 20,
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      scheduleList: [],
      bindList: [],
      elementList: [
        {name: '', vendor_custom_id: '', remark: ''},
        {name: '', vendor_custom_id: '', remark: ''},
        {name: '', vendor_custom_id: '', remark: ''},
        {name: '', vendor_custom_id: '', remark: ''},
        {name: '', vendor_custom_id: '', remark: ''}
      ],
      addElementList: [],
      addAmount: 5
    }
  },
  methods: {
    gotoOut () {
      this.$router.go(-1)
    },
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    clickPage (index) {
      this.tableIndex = index
      this.getBindingList()
    },
    checkDoubleStore (storeIdList) {
      console.log(storeIdList)
      var newScheduleList = []
      for (let key in storeIdList) {
        newScheduleList.push(storeIdList[key][0])
      }
      console.log(newScheduleList)
      this.setGantt(newScheduleList)
    },
    pageShow (index) {
      var num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    },
    getBindingList () {
      switch (this.tab) {
        case 2:
          this.bindList = this.optionList
          break
        case 20:
          this.bindList = this.adjustList
          break
        case 10:
          this.bindList = this.categoryList
          break
        case 1:
          this.bindList = this.productList
          break
        case 11:
          this.bindList = this.blockList
          break
        case 3:
          this.bindList = this.packageList
          break
      }
    },
    addElement () {
      for (var i = 0; i < this.addAmount; i++) {
        this.elementList.push({name: '', vendor_custom_id: '', remark: ''})
      }
    },
    randomString () {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'
      var stringLength = Math.random() * (10 - 8) + 8
      var randomString = ''
      for (var i = 0; i < stringLength; i++) {
        var rNum = Math.floor(Math.random() * chars.length)
        randomString += chars.substring(rNum, rNum + 1)
      }
      return randomString
    },
    checkAddBinding () {
      var self = this
      var addList = []
      this.elementList.find(function (o) {
        if (o.name) {
          if (!o.vendor_custom_id) {
            var random = self.randomString()
            o.vendor_custom_id = 'Nidin' + random
            addList.push(o)
          } else addList.push(o)
        }
      })
      if (addList.length) {
        self.addElementList = addList
        self.addBindingItem()
      } else {
        self.$notify({
          title: '提醒',
          text: '無任何' + self.tabName + '被新增',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      }
    },
    addBindingItem () {
      console.log('addBindingItem')
      const data = {
        list: this.addElementList,
        type: this.tab
      }
      const url = this.base + this.id + '/itemBinding'
      this.getDataH('post', url, data, (res) => {
        console.log(res.data)
        this.$notify({
          title: '提醒',
          text: '已新增' + this.tabName,
          duration: 3000,
          type: 'success',
          width: 400
        })

        if (this.isStore && this.getRoleType !== 10) {
          this.$router.push({
            name: 'StoreMenuBindingPos',
            params: {
              brand_id: this.$route.params.brand_id,
              store_id: this.$route.params.store_id
            },
            query: {
              tab: this.tab
            }
          })
        } else {
          this.$router.push({
            name: 'BindingPos',
            params: {
              brand_id: this.$route.params.brand_id
            },
            query: {
              tab: this.tab
            }
          })
        }
      })
    }
  },
  computed: {
    ...mapGetters(['getRoleType']),
    tab () {
      const name = this.$route.name
      switch (name) {
        case 'crAdjusts':
        case 'StoreMenuAdjustCreate':
          return 20
        case 'crBlocks':
        case 'StoreMenuBlockCreate':
          return 11
        case 'crCategories':
        case 'StoreMenuCategoryCreate':
          return 10
        case 'crOptions':
        case 'StoreMenuOptionCreate':
          return 2
        case 'crPackages':
        case 'StoreMenuPackageCreate':
          return 3
        case 'crProducts':
        case 'StoreMenuProductCreate':
          return 1
      }
    },
    tabName () {
      switch (this.tab) {
        case 2: return '配料'
        case 20: return '配料群組'
        case 10: return '商品分類'
        case 1: return '商品'
        case 11: return '品項選擇區'
        case 3: return '套餐'
      }
    },
    tabNamePlaceholder () {
      switch (this.tab) {
        case 2: return '配料名稱'
        case 20: return '配料群組名稱'
        case 10: return '商品分類名稱'
        case 1: return '商品名稱'
        case 11: return '品項選擇區名稱'
        case 3: return '套餐名稱'
      }
    },
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.total / this.count)
    }
  },
  watch: {
    menuState () {
      this.tableIndex = 1
      this.pageGroup = 1
      this.getBindingList()
    },
    tab () {
      this.getBindingList()
    }
  },
  created () {
    this.getBindingList()
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>
<style lang="sass">
.menu-info
  min-height: 120px
  width: 100%
  text-align: center
  *
    padding: 0
    margin: 0
    line-height: 25px
.m-b-15
  margin-bottom: 15px !important
.btn-edit-all, .btn-del-all
  margin-right: 15px
  z-index: 100
.nav-page-back, .page-number, .nav-page-next, .nav-zoomIn, .nav-zoomOut
  display: none !important
.fn-gantt .leftPanel
  width: 100px !important
.fn-gantt .leftPanel .fn-wide, .fn-gantt .leftPanel .fn-wide .fn-label
  font-size: 14px
.fn-gantt .navigate
  padding: 10px 0 10px 10px !important
@media screen and (max-width: 499px)
  .min-m-t-10
    margin-top: 25px
</style>



// WEBPACK FOOTER //
// CrBinding.vue?058523f0